<template>
  <div class="lxm-share">
    <!--<lxm-nav :title="'羊宝宝和小兔兔的展览筹款'"></lxm-nav>-->
    <div class="page">
      <h2 class="subtitle">您的{{ state.type }}链接是</h2>
      <lxm-row class="lxm-share__row" :name="state.link" :href="state.link"></lxm-row>
      <h2 class="subtitle">您还可以长按保存二维码，转发到朋友圈</h2>
      <div class="lxm-share__qrcode-container box">
        <div class="lxm-share__qrcode-title">{{ state.name }}</div>
        <img class="lxm-share__qrcode" :src="state.qrcodeSrc"/>
        <div class="lxm-share__qrcode-by">By {{ state.by }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-share__row.lxm-row.box:not(:last-child)
    margin-bottom: spacing-big
  .lxm-share__qrcode-container
    text-align: center
    &.box
      padding: siz(30) 0
  .lxm-share__qrcode-title
    font-size: size-small
  .lxm-share__qrcode
    width: siz(110)
    height: siz(110)
    margin: spacing auto
  .lxm-share__qrcode-by
    font-size: size-smaller
    color: grey
</style>

<script>
  import LxmNav from './common/LxmNav.vue'
  import LxmRow from './common/LxmRow.vue'
  import * as aTypes from '../../store/action-types'
  export default {
    components: {
      LxmNav,
      LxmRow
    },
    computed: {
      state () {
        return this.$store.state.share
      }
    },
    mounted () {
      this.$store.dispatch(aTypes.GET_SHARE, {
        formId: this.$route.query.formId,
        projectId: this.$route.query.projectId,
        activityId: this.$route.query.activityId
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Share.vue?4611ec40